import axios from "axios";
import {
  SuperAdmin_Service_URL,
  AssetManagementService_URL,
  RequestManagement_URL,
} from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../Logout/actions";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// Save RequestType

export const saveRequestTypeActions = {
  SAVE_REQUEST_TYPE: "SAVE_REQUEST_TYPE",
  SAVE_REQUEST_TYPE_STATUS: "SAVE_REQUEST_TYPE_STATUS",
  SAVE_REQUEST_TYPE_SUCCESS: "SAVE_REQUEST_TYPE_SUCCESS",
  SAVE_REQUEST_TYPE_FAILURE: "SAVE_REQUEST_TYPE_FAILURE",
};

export function saveRequestTypeRequest() {
  return {
    type: saveRequestTypeActions.SAVE_REQUEST_TYPE,
    isPosting: true,
  };
}

export function saveRequestTypeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveRequestTypeActions.SAVE_REQUEST_TYPE_SUCCESS,
      payload: props,
    });
  };
}

export function saveRequestTypeFailure(error) {
  return {
    type: saveRequestTypeActions.SAVE_REQUEST_TYPE_FAILURE,
    payload: error,
  };
}

export function saveRequestTypeError(error) {
  return {
    type: saveRequestTypeActions.SAVE_REQUEST_TYPE_FAILURE,
    payload: error,
  };
}

export function saveRequestType(props) {
  var value = {
    id: props.id || 0,
    name: props.name,
    applicableFor: props.applicableFor,
    description: props.description,
    statusMappingDtos: props.statusMappingDetails,
  };

  return (dispatch) =>
    axios({
      method: "post",
      data: value,
      url: `${RequestManagement_URL}/saveRequestType`,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(saveRequestTypeRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveRequestTypeSuccess(response));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(saveRequestTypeError(error));
          throw error;
        }
      })
      .catch((err) => {
        //
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          return err;
          // dispatch(saveRequestTypeError(err));
          // switch (err.response.status) {
          //   case 400:

          //   break;

          //   map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //   map.forEach(ele => (err = ele));

          //   dispatch(saveRequestTypeError(err));
          //   break;
          // case 406:
          //   // map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //   // map.forEach(ele => (err = ele));

          //   // dispatch(saveRequestTypeError(err));
          //   return err.response;
          //   break;
          // case 500:
          //   dispatch(saveRequestTypeError("Server Error"));
          //   break;
          // default:
          //   dispatch(saveRequestTypeError("Unknown Error"));
          //   break;
          // }
        } else {
          // //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

// Delete RequestType

export const deleteRequestTypeActions = {
  DELETE_REQUEST_TYPE: "DELETE_REQUEST_TYPE",
  DELETE_REQUEST_TYPE_STATUS: "DELETE_REQUEST_TYPE_STATUS",
  DELETE_REQUEST_TYPE_SUCCESS: "DELETE_REQUEST_TYPE_SUCCESS",
  DELETE_REQUEST_TYPE_FAILURE: "DELETE_REQUEST_TYPE_FAILURE",
};

export function deleteRequestTypeRequest() {
  return {
    type: deleteRequestTypeActions.DELETE_REQUEST_TYPE,
    isPosting: true,
  };
}

export function deleteRequestTypeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: deleteRequestTypeActions.DELETE_REQUEST_TYPE_SUCCESS,
      payload: props,
    });
  };
}

export function deleteRequestTypeFailure(error) {
  return {
    type: deleteRequestTypeActions.DELETE_REQUEST_TYPE_FAILURE,
    payload: error,
  };
}

export function deleteRequestTypeError(error) {
  return {
    type: deleteRequestTypeActions.DELETE_REQUEST_TYPE_FAILURE,
    payload: error,
  };
}

export function deleteRequestType(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${AssetManagementService_URL}/deleteRequestType?requestTypeId=` +
        params.requestTypeID,
      headers: {
        authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(deleteRequestTypeRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(deleteRequestTypeSuccess(response));
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(deleteRequestTypeError(error));
          throw error;
        }
      })
      .catch((err) => {
        //
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(deleteRequestTypeError(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(deleteRequestTypeError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(deleteRequestTypeError(err));
              break;
            case 500:
              dispatch(deleteRequestTypeError("Server Error"));
              break;
            default:
              dispatch(deleteRequestTypeError("Unknown Error"));
              break;
          }
        } else {
          // //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

// clear  details
export const ClearFormDetailsActions = {
  CLEAR_FORM_DETAILS: "CLEAR_FORM_DETAILS",
};

export function clearFormData() {
  return (dispatch) => dispatch(clearFormDetails());
}

export function clearFormDetails() {
  return {
    type: ClearFormDetailsActions.CLEAR_FORM_DETAILS,
  };
}

// get  details by id

///////GET LOCATION BY ID

export const GetRequestTypeDetailsActions = {
  FETCH_REQUEST_TYPE_DETAILS: "FETCH_REQUEST_TYPE_DETAILS",
  FETCH_REQUEST_TYPE_DETAILS_STATUS: "FETCH_REQUEST_TYPE_DETAILS_STATUS",
  FETCH_REQUEST_TYPE_DETAILS_FULFILLED: "FETCH_REQUEST_TYPE_DETAILS_FULFILLED",
  FETCH_REQUEST_TYPE_DETAILS_REJECTED: "FETCH_REQUEST_TYPE_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getRequestTypeDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${RequestManagement_URL}/findRequestTypeById?id=` + params.id,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getRequestTypeDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getRequestTypeDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getRequestTypeDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeDetailsError(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeDetailsError(err));
              break;
            case 500:
              dispatch(getRequestTypeDetailsError("Server Error"));
              break;
            default:
              dispatch(getRequestTypeDetailsError("Unknown Error"));
              break;
          }
        } else {
          // //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getRequestTypeDetailsRequest() {
  return {
    type: GetRequestTypeDetailsActions.FETCH_REQUEST_TYPE_DETAILS,
    isPosting: true,
  };
}
export function getRequestTypeDetailsError(error) {
  return {
    type: GetRequestTypeDetailsActions.FETCH_REQUEST_TYPE_DETAILS_REJECTED,
    payload: error,
  };
}

export function getRequestTypeDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetRequestTypeDetailsActions.FETCH_REQUEST_TYPE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getRequestTypeDetailsStatus() {
  return (dispatch) => dispatch(getRequestTypeDetailsStatusRequest());
}
export function getRequestTypeDetailsStatusRequest() {
  return {
    type: GetRequestTypeDetailsActions.FETCH_REQUEST_TYPE_DETAILS_STATUS,
  };
}

export function setDetailsError() {
  return (dispatch) => dispatch(getRequestTypeDetailsErrorRequest());
}
export function getRequestTypeDetailsErrorRequest() {
  return {
    type: GetRequestTypeDetailsActions.SET_EDIT_ERROR,
  };
}

//////////////////////////////////////////////////////////////////////////////////////////
export const UploadexcelActions = {
  CREATE_UPLOAD_EXCEL: "CREATE_UPLOAD_EXCEL",
  CREATE_UPLOAD_EXCEL_SUCCESS: "CREATE_UPLOAD_EXCEL_SUCCESS",
  CREATE_UPLOAD_EXCEL_FAILURE: "CREATE_UPLOAD_EXCEL_FAILURE",
};

export function UploadexcelRequest() {
  return {
    type: UploadexcelActions.CREATE_UPLOAD_EXCEL,
    isPosting: true,
  };
}

export function UploadexcelSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: UploadexcelActions.CREATE_UPLOAD_EXCEL_SUCCESS,
      payload: props,
    });
  };
}

export function UploadexcelFailure(error) {
  return {
    type: UploadexcelActions.CREATE_UPLOAD_EXCEL_FAILURE,
    payload: error,
  };
}

export function UploadExcel(props) {
  let data = new FormData();
  data.append("requestTypes", props.Excel);

  return (dispatch) =>
    axios({
      method: "post",
      data: data,
      url: `${AssetManagementService_URL}/bulkUploadExcel`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.access_token,
        transactionId: "1",
      },
    })
      .then((response) => {
        dispatch(UploadexcelRequest());
        if (response.status === 200) {
          dispatch(UploadexcelSuccess(response));
        } else {
          const error = new Error(response.statusText);
          dispatch(UploadexcelFailure(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(UploadexcelFailure(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(UploadexcelFailure(err));
              break;
            case 500:
              dispatch(UploadexcelFailure("Server Error"));
              break;
            default:
              dispatch(UploadexcelFailure("Unknown Error"));
              break;
          }
        } else {
          dispatch(UploadexcelFailure("Internal Server Error"));
          dispatch(clearLogoutData());
        }
      });
}
///ACTIVE ASSETS :LIST

export const GetActiveRequestTypeTypeActions = {
  FETCH_ACTIVE_REQUEST_TYPE: "FETCH_ACTIVE_REQUEST_TYPE",
  FETCH_ACTIVE_REQUEST_TYPE_STATUS: "FETCH_ACTIVE_REQUEST_TYPE_STATUS",
  FETCH_ACTIVE_REQUEST_TYPE_FULFILLED: "FETCH_ACTIVE_REQUEST_TYPE_FULFILLED",
  FETCH_ACTIVE_REQUEST_TYPE_REJECTED: "FETCH_ACTIVE_REQUEST_TYPE_REJECTED",
};

export function getActiveRequestTypeList(params) {
  return (dispatch) =>
    axios({
      method: "POST",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${RequestManagement_URL}/getAllRequestTypePagination?start=0&sortOrder=desc&booleanfield=true&status=true&sortField=id&length=0`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveRequestTypeListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveRequestTypeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveRequestTypeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveRequestTypeListError(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveRequestTypeListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveRequestTypeListError(err));
              break;
            case 500:
              dispatch(getActiveRequestTypeListError("Server Error"));
              break;
            default:
              dispatch(getActiveRequestTypeListError("Unknown Error"));
              break;
          }
        } else {
          // //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveRequestTypeListRequest() {
  return {
    type: GetActiveRequestTypeTypeActions.FETCH_ACTIVE_REQUEST_TYPE,
    isPosting: true,
  };
}
export function getActiveRequestTypeListError(error) {
  return {
    type: GetActiveRequestTypeTypeActions.FETCH_ACTIVE_REQUEST_TYPE_REJECTED,
    payload: error,
  };
}

export function getActiveRequestTypeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveRequestTypeTypeActions.FETCH_ACTIVE_REQUEST_TYPE_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveRequestTypeListStatus() {
  return (dispatch) => dispatch(getActiveRequestTypeListStatusRequest());
}
export function getActiveRequestTypeListStatusRequest() {
  return {
    type: GetActiveRequestTypeTypeActions.FETCH_ACTIVE_REQUEST_TYPE_STATUS,
  };
}


/////////////////////////////////////////////////

///////GET LOCATION BY ID

export const GetRequestTypeForChecklistDetailsActions = {
  FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS: "FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS",
  FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_STATUS: "FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_STATUS",
  FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_FULFILLED: "FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_FULFILLED",
  FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_REJECTED: "FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getRequestTypeforChecklistDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${RequestManagement_URL}/getAllRequestTypeForChecklist`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getRequestTypeForChecklistDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getRequestTypeForChecklistDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getRequestTypeForChecklistDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeForChecklistDetailsError(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeForChecklistDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getRequestTypeForChecklistDetailsError(err));
              break;
            case 500:
              dispatch(getRequestTypeForChecklistDetailsError("Server Error"));
              break;
            default:
              dispatch(getRequestTypeForChecklistDetailsError("Unknown Error"));
              break;
          }
        } else {
          // //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getRequestTypeForChecklistDetailsRequest() {
  return {
    type: GetRequestTypeForChecklistDetailsActions.FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS,
    isPosting: true,
  };
}
export function getRequestTypeForChecklistDetailsError(error) {
  return {
    type: GetRequestTypeForChecklistDetailsActions.FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_REJECTED,
    payload: error,
  };
}

export function getRequestTypeForChecklistDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetRequestTypeForChecklistDetailsActions.FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getRequestTypeForChecklistDetailsStatus() {
  return (dispatch) => dispatch(getRequestTypeForChecklistDetailsStatusRequest());
}
export function getRequestTypeForChecklistDetailsStatusRequest() {
  return {
    type: GetRequestTypeForChecklistDetailsActions.FETCH_REQUEST_TYPE_FOR_CHECKLIST_DETAILS_STATUS,
  };
}

